const animateClass = (type, element, className) => {
    return new Promise((resolve) => {
        const finishAnimation = () => {
            element.removeEventListener(type, finishAnimation);

            element.classList.remove(className);

            resolve();
        };

        element.addEventListener(type, finishAnimation);

        element.classList.add(className);

        if (window.getComputedStyle(element, null).display === 'none') {
            finishAnimation();
        }
    });
};

export const animateByClass    = (element, className) => animateClass('animationend', element, className);
export const transitionByClass = (element, className) => animateClass('transitionend', element, className);
